module.exports = __webpack_public_path__ + "static/media/economic-overview-with-banner.81dac420.png";